export default {
  shiftname: {
    header: 'Shift Name & Description',
    headercss: 'vmHeader',
    subheader: 'Shift Name',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  description: {
    header: '',
    headercss: 'vmHeader',
    subheader: 'Internal description for other admins who would view this setting',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  shiftcategoryid: {
    header: 'Shift Category',
    headercss: 'vmHeader',
    subheader: 'Selected shift cycle',
    subheadercss: 'vmSubHeader',
    values: '<val> shift in a day',
  },
  isflexible: {
    header: '',
    headercss: 'vmHeader',
    subheader: 'Is shift a flexible-shift?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  shifttiming: [
    {
      shiftbegintime: {
        header: 'Shift Timings',
        headercss: 'vmHeader',
        subheader: "Shift One's Begin Time",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      shiftendtime: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift One's End Time",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      earlycutoff: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift One's Start-off Timings",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      endcutoff: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift One's Cut-off Timings",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
    },
    {
      shiftbegintime: {
        header: '-------------------',
        headercss: 'vmHeader',
        subheader: "Shift Second's Begin Time",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      shiftendtime: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift Second's End Time",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      earlycutoff: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift Second's Start-off Timings",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      endcutoff: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift Second's Cut-off Timings",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
    },
    {
      shiftbegintime: {
        header: '-------------------',
        headercss: 'vmHeader',
        subheader: "Shift Third's Begin Time",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      shiftendtime: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift Third's End Time",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      earlycutoff: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift Third's Start-off Timings",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      endcutoff: {
        header: '',
        headercss: 'vmHeader',
        subheader: "Shift Third's Cut-off Timings",
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
    },
  ],

  shiftcolour: {
    header: 'Color Code',
    headercss: 'vmHeader',
    subheader: 'Color code for this shift is',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
};
